export default __webpack_public_path__ + "static/artifakt-legend-medium-d72a728f11a76d2eb8e5680b204f8308.ttf";